export default {"src":"/_next/static/media/Group-25839.39e1d806.svg","height":126,"width":126};